import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../contexts/LocaleContext';
import { themeClasses } from '../../config/themeClasses';
import BrandLogo from '../Brand/BrandLogo';

export default function LandingFooter() {
  const { t } = useLocale();

  return (
    <footer className="border-t border-border-light py-10">
      <div className={`${themeClasses.landing.containerWide} flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between`}>
        <BrandLogo name={t('appName')} to="/" />
        <div className="flex flex-wrap items-center gap-4 text-sm text-text-secondary">
          <Link to="/login" className="hover:text-text-primary transition-colors">
            {t('landingNavLogin')}
          </Link>
        </div>
        <p className="text-xs text-text-tertiary">{t('footerCopyright')}</p>
      </div>
    </footer>
  );
}
